export const TrashIcon = () => {
  return (
    <svg
      className="hover:text-darkblue text-[#9CA3AF]"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="24"
      viewBox="0 0 18 24"
      fill="currentColor"
    >
      <path
        d="M12.1164 3.3002V3.63353H12.4497H15.3372C16.2447 3.63353 16.9914 4.38839 16.9914 5.2502V6.3752C16.9914 7.02576 16.5869 7.61893 15.9954 7.86798L15.8027 7.94912L15.7918 8.15793L15.1168 21.1704L15.1168 21.1704L15.1165 21.1773C15.0848 22.1926 14.2244 23.0294 13.1622 23.0294H4.72471C3.66833 23.0294 2.83571 22.2344 2.77007 21.1698L2.17018 8.1973L2.16047 7.98713L1.96656 7.90548C1.37157 7.65496 0.97054 7.09709 0.97054 6.4127V5.2877C0.97054 4.38429 1.7213 3.63353 2.62471 3.63353H5.51221H5.84554V3.3002V2.6627C5.84554 1.72179 6.5963 0.971029 7.53721 0.971029H10.4247C11.3656 0.971029 12.1164 1.72179 12.1164 2.6627V3.3002ZM6.90387 2.6627V2.99603H6.94137V3.3002V3.63353H7.27471H10.7997H11.133V3.3002V2.6627C11.133 2.2911 10.8338 1.99186 10.4622 1.99186H7.57471C7.20311 1.99186 6.90387 2.2911 6.90387 2.6627ZM3.59971 8.06686H3.25027L3.26674 8.41591L3.86642 21.1215C3.8714 21.6153 4.29523 22.0085 4.79971 22.0085H13.1997C13.7163 22.0085 14.111 21.6097 14.168 21.154L14.1696 21.1413L14.1702 21.1284L14.7702 8.41591L14.7866 8.06686H14.4372H3.59971ZM2.66221 4.65436C2.2639 4.65436 2.02887 4.9815 2.02887 5.2877V6.4127C2.02887 6.811 2.35601 7.04603 2.66221 7.04603H15.3372C15.7355 7.04603 15.9705 6.71889 15.9705 6.4127V5.2877C15.9705 4.88939 15.6434 4.65436 15.3372 4.65436H2.66221Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.666667"
      />
      <path
        d="M8.99971 11.6631C8.54971 11.6631 8.13721 12.0381 8.13721 12.5256V18.3381C8.13721 18.7881 8.51221 19.2006 8.99971 19.2006C9.44971 19.2006 9.86221 18.8256 9.86221 18.3381V12.4881C9.86221 12.0381 9.44971 11.6631 8.99971 11.6631Z"
        fill="currentColor"
      />
      <path
        d="M12.4875 12.3756C12.0375 12.3381 11.625 12.7131 11.5875 13.1631L11.3625 17.4756C11.325 17.9256 11.7 18.3381 12.15 18.3756H12.1875C12.6375 18.3756 13.0125 18.0381 13.0125 17.5881L13.2375 13.2756C13.3125 12.7881 12.9375 12.4131 12.4875 12.3756Z"
        fill="currentColor"
      />
      <path
        d="M5.47466 12.3756C5.02466 12.4131 4.64966 12.7881 4.68716 13.2756L4.94966 17.6256C4.98716 18.0756 5.36216 18.4131 5.77466 18.4131H5.81216C6.26216 18.3756 6.63716 18.0006 6.59966 17.5131L6.37466 13.1631C6.33716 12.7131 5.92466 12.3381 5.47466 12.3756Z"
        fill="currentColor"
      />
    </svg>
  );
};
